exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-2b6fa10e] .el-dialog__body{padding:10px 25px 30px}.detail-container .detail-summary[data-v-2b6fa10e]{font-size:26px}.detail-container .detail-tips[data-v-2b6fa10e]{margin-top:8px;color:#333333A2}.detail-container .detail-table[data-v-2b6fa10e]{margin-top:20px;max-height:calc(80vh - 220px);overflow-y:auto}.detail-container .detail-table[data-v-2b6fa10e] .detail-table-header th{background-color:#f5f7fa;font-size:14px}\n", ""]);

// exports
